<template>
  
  <search-picker 
    ref="searchPicker"
    path="suppliers" 
    attributes="id,shortName,city,state"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"

  export default {

    name: "SupplierPicker",

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },      
    },
    
    components: {
      SearchPicker,
    },  

    methods: {

      renderTitle(supplier) {
        return supplier.shortName
      },

      renderDescription(supplier) {
        
        if (!supplier.city)
          return ""
         
        return `<div class="m-t-10"><i class="map marker alternate blue icon"></i> ${supplier.city.trim() + " / " + supplier.state}</div>`
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(supplier) {
        this.$emit("onPick", supplier)
      },

      setSelected(supplier) {
        this.$refs.searchPicker.setSelected(supplier)
      },
    },
  }

</script>